import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container-9" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "sm:col-span-1" }, null, -1)
const _hoisted_3 = { class: "sm:col-span-5 main-content" }
const _hoisted_4 = {
  key: 0,
  class: "question-label"
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 4,
  class: "w-full mb-4"
}
const _hoisted_8 = { class: "text-sm mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ActionButton = _resolveComponent("ActionButton")!
  const _component_Bar = _resolveComponent("Bar")!
  const _component_BackNextButtons = _resolveComponent("BackNextButtons")!
  const _component_ScreenWrapper = _resolveComponent("ScreenWrapper")!
  const _directive_t = _resolveDirective("t")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["screen-content", _ctx.config.wrapperClasses])
  }, [
    _createVNode(_component_ScreenWrapper, {
      "class-name": "pt-0",
      next: _ctx.next,
      screen: _ctx.screen,
      "hide-arrow": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            (_ctx.config.title)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _withDirectives(_createElementVNode("span", null, null, 512), [
                    [_directive_t, _ctx.config.title]
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.config.textPart1)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 1,
                  class: "mt-4",
                  innerHTML: _ctx.$t(_ctx.config.textPart1, {name: _ctx.state.nickname.value})
                }, null, 8, _hoisted_5))
              : _createCommentVNode("", true),
            (_ctx.config.textPart2)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 2,
                  class: "mt-4",
                  innerHTML: _ctx.$t(_ctx.config.textPart2, {name: _ctx.state.nickname.value})
                }, null, 8, _hoisted_6))
              : _createCommentVNode("", true),
            (!_ctx.showStats)
              ? (_openBlock(), _createBlock(_component_ActionButton, {
                  key: 3,
                  class: "mt-4",
                  text: "buttons.see",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showStats = true))
                }))
              : _createCommentVNode("", true),
            (_ctx.showStats && _ctx.chartReady)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("p", _hoisted_8, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.config.selectedValues, (option, key) => {
                      return (_openBlock(), _createElementBlock("span", { key: key }, [
                        _createTextVNode(_toDisplayString(_ctx.$t(option)) + ": ", 1),
                        _createElementVNode("b", null, _toDisplayString(_ctx.state.answers.value?.[key] ? _ctx.$t(`${_ctx.config.chartLabelsPrefix}.${_ctx.state.answers.value?.[key]}`) : '/'), 1)
                      ]))
                    }), 128))
                  ]),
                  _createVNode(_component_Bar, {
                    id: "my-chart-id",
                    options: _ctx.chartOptions,
                    data: _ctx.chartData
                  }, null, 8, ["options", "data"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.showStats)
              ? (_openBlock(), _createBlock(_component_BackNextButtons, {
                  key: 5,
                  "go-to": _ctx.goTo,
                  "next-screen": _ctx.config.screenNext,
                  class: "mt-auto"
                }, null, 8, ["go-to", "next-screen"]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.config.bgImage)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "col-span-3 h-full flex-col items-center flex bg-project2-light",
                style: _normalizeStyle(`background-image: ${_ctx.config.bgImage}; background-size: cover; background-position: center;`)
              }, null, 4))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["next", "screen"])
  ], 2))
}